export default __webpack_public_path__ + "static/media/rent.505e74b8.jpg";